export function quantityDifference(currentQuantity?: number, proposedQuantity?: number): number | undefined {
  if (currentQuantity === undefined || proposedQuantity === undefined) {
    return undefined;
  }

  return proposedQuantity - currentQuantity;
}
